import cn from 'classnames';
import { ListViewProduct } from 'models/ListViewProduct';
import Button from 'components/Shared/Button';
import styles from './arrow.scss';
import { useState, memo } from 'react';
import { getGetEnergySvgContent } from 'services/ApiEnergyService';
import { EnergyModal } from 'components/Shared/Product/energyModal';
import connect from 'components/Shared/connect';
import { handleServerError } from 'components/Shared/server';
import { IEnergyDeclaration } from 'models/IEnergyLabel';
import { ReactComponent } from 'models/ReactComponent';
import { Picture } from 'models/Picture';
import { hasElements } from 'utils';

type OwnProps = Pick<IEnergyDeclaration, 'efficiencyArrow' | 'efficiencyLabel'> &
  Pick<ListViewProduct, 'productId'> & {
    className?: string;
    wrapperClassName?: string;
    appearance?: 'small' | 'smallMedium' | 'medium' | 'large';
    onClose?: () => void;
  };

type MergedProps = OwnProps & {
  handleError: () => void;
};

const Arrow = memo(
  ({
    efficiencyArrow,
    className,
    wrapperClassName,
    appearance = 'small',
    productId,
    onClose,
    handleError,
    ...props
  }: MergedProps) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [efficiencyLabels, setEfficiencyLabels] = useState<ReactComponent[] | undefined>([]);
    const [efficiencyLabels2020, setEfficiencyLabels2020] = useState<Picture[] | undefined>([]);

    const labels = props.efficiencyLabel || efficiencyLabels;
    const labels2020 = efficiencyLabels2020;

    const openModal = () => {
      setModalOpen(true);
      if (!hasElements(labels)) {
        getGetEnergySvgContent(productId, true)
          .then(content => {
            setEfficiencyLabels(content.efficiencyLabels);
            setEfficiencyLabels2020(content.energyLabelImage2020);
          })
          .catch(handleError);
      }
    };

    const closeModal = () => {
      setModalOpen(false);
      onClose && onClose();
    };

    return (
      <>
        <Button onClick={openModal} appearance="clear" className={wrapperClassName}>
          <img
            className={cn(styles.arrow, className, {
              [styles.small]: appearance === 'small',
              [styles.smallMedium]: appearance === 'smallMedium',
              [styles.medium]: appearance === 'medium',
              [styles.large]: appearance === 'large'
            })}
            src={efficiencyArrow}
          />
        </Button>
        <EnergyModal
          close={closeModal}
          isOpen={modalOpen && (hasElements(labels) || hasElements(labels2020))}
          efficiencylabels={labels}
          energyLabelImage2020={labels2020}
        />
      </>
    );
  }
);

export const EnergyArrow = connect<MergedProps, OwnProps>(undefined, dispatch => ({
  handleError: handleServerError(dispatch)
}))(Arrow);
